import { handleActions } from 'redux-actions'
import { fromJS, Set } from 'immutable'

import * as Actions from 'actions/saved_searches'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  loading: false,
  resolving: false,
  initialSearchLoaded: false,
  tab: 'saved_searches',
  menuCollapsedGroupIds: Set(),
  menuGrouped: true
})

export default handleActions({
  [Actions.fetchSavedSearchesTimelinesStart]: state => state.set('loading', true),
  [Actions.fetchSavedSearchesTimelinesError]: state => state.set('loading', false),
  [Actions.fetchSavedSearchesTimelinesSuccess]: state => state.set('loading', false),

  [Actions.resolveSavedSearchStart]: state => state.set('resolving', true),
  [Actions.resolveSavedSearchError]: state => state.set('resolving', false),
  [Actions.resolveSavedSearchSuccess]: state => state.set('resolving', false),

  [Actions.setInitialSearchLoaded]: (state, { payload }) => state.set('initialSearchLoaded', payload),

  [Actions.setTab]: (state, { payload }) => state.set('tab', payload),

  [Actions.toggleMenuGroup]: (state, { payload: groupId }) => state.update('menuCollapsedGroupIds', ids => {
    const id = String(groupId)

    return ids.has(id) ? ids.delete(id) : ids.add(id)
  }),
  [Actions.collapseMenuGroups]: (state, { payload: groupIds }) => state.update(
    'menuCollapsedGroupIds',
    ids => ids.union(Set((groupIds || []).map(id => String(id))))
  ),
  [Actions.expandMenuGroups]: state => state.set('menuCollapsedGroupIds', Set()),
  [Actions.toggleMenuGrouped]: state => state.update('menuGrouped', grouped => !grouped),

  [AppActions.resetState]: () => initialState
}, initialState)
